import styled, { css } from 'foundations-theming-specialty/utils';
import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InnerArrow = styled.path.withConfig({
  displayName: "ExpandCollapseIcon__InnerArrow",
  componentId: "sc-1vxtlu9-0"
})(({
  $isPinned,
  theme
}) => {
  return css(["fill:", ";", ";"], theme.color['global-shell-icon-nav-item-default'], $isPinned ? css(["transform:scale(-1,1);transform-origin:center;"]) : '');
});
const Outline = styled.path.withConfig({
  displayName: "ExpandCollapseIcon__Outline",
  componentId: "sc-1vxtlu9-1"
})(({
  theme
}) => {
  return css(["fill:", ";"], theme.color['global-shell-icon-nav-item-selected']);
});
const ExpandCollapseIcon = ({
  isPinned
}) => {
  return /*#__PURE__*/_jsxs(SVGIconBase, {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx(Outline, {
      d: "M3.0675 21C3.0675 21 3 20.97 3 20.9325L3 3.06C3 3.06 3.03 2.9925 3.0675 2.9925L20.9325 2.9925C20.9325 2.9925 21 3.0225 21 3.06L21 20.9325C21 20.9325 20.97 21 20.9325 21L3.06 21M3.06 22.5L20.9325 22.5C21.795 22.5 22.5 21.8025 22.5 20.9325L22.5 3.06C22.5 2.1975 21.8025 1.4925 20.9325 1.4925L3.06 1.4925C2.1975 1.4925 1.4925 2.19 1.4925 3.06L1.4925 20.9325C1.4925 21.795 2.19 22.5 3.06 22.5Z"
    }), /*#__PURE__*/_jsx(InnerArrow, {
      d: "M9.2325 7.6875L13.845 12.0375L9.315 16.3125C8.94 16.6725 8.9175 17.265 9.2775 17.64C9.63 18.015 10.2225 18.03 10.5975 17.6775L15.8475 12.7275C16.2225 12.3825 16.245 11.7975 15.9 11.4225C15.8925 11.4075 15.885 11.4 15.87 11.385C15.84 11.3475 15.81 11.31 15.7725 11.2725L10.5225 6.3225C10.3425 6.1575 10.11 6.0675 9.8775 6.0675C9.63 6.0675 9.3825 6.1725 9.195 6.3675C8.8425 6.7425 8.8575 7.335 9.2325 7.6875Z",
      $isPinned: isPinned
    })]
  });
};
export default ExpandCollapseIcon;